exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! rtl:begin:ignore */\n#dashboard-analytics .greet-user{\n  position:relative\n}\n#dashboard-analytics .greet-user .decore-left{\n  position:absolute;\n  left:0;\n  top:0\n}\n#dashboard-analytics .greet-user .decore-right{\n  position:absolute;\n  right:0;\n  top:0\n}\n@media(max-width: 576px){\n#dashboard-analytics .decore-left,#dashboard-analytics .decore-right{\n    width:140px\n}\n}\n\n/*! rtl:end:ignore */", ""]);

// exports
